const PricePerHour = "PricePerHour";
const PricePerMinute = "PricePerMinute";
const MinimalPrice = "MinimalPrice";
const CodeType = "CodeType";
const ResetTime = "ResetTime";
export { PricePerHour, PricePerMinute, MinimalPrice, CodeType, ResetTime };
